/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import React, { useState } from 'react';
import { useEffect } from 'react';
import { Card, TabContent } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { ResponseResult } from '../../apis/response';
import Footer from '../../components/Footer/Footer2';
import ModalMembercardRequest from '../../components/Modal/ModalMembercardRequest';
import NavBar from '../../components/NavBar/NavBar';
import Tab from '../../components/Tab/Tab';
import { mypage_tab } from '../../configs/base';
import { csmsGetApiKey, csmsGetUser } from '../../stores/actions/csms_action';
import { scroll_gray, stroke_gray1, stroke_gray2, typo_light_blue } from '../../styles/colors';
import { BtnOutLineGray2, MyPageWrap } from '../../styles/themes';
import { cardNoFormat } from '../../utils/utils';
import { serverErrAlertMessage } from '../../validations/messages/messages';

const rowStyle = css`display: flex; align-items: center; font-weight: 400; font-size: 13px; line-height: 19px; justify-content: space-between; margin-top: 27px; padding-bottom: 27px;`;

const CARD_OFFER_LABEL = {
    NONE: "미발급",
    REQUEST: "신청완료",
    COMPLETE: "발급완료",
};

function MembercardPage() {
    const dispatch = useDispatch();
    const user = useSelector(state => state.user);
    const [UserInfo, setUserInfo] = useState({});
    const [CsmsToken, setCsmsToken] = useState(null);
    const [ModalRequestShow, setModalRequestShow] = useState(false);

    const UserCards = UserInfo.userCards ?? [];
    const MobileCard = UserCards.find(card => card.ty === "ONLINE");
    const PhysicalCard = UserCards.find(card => card.ty === "NORMAL");
    const CardOffer = UserInfo.cardOffer ?? "NONE";

    useEffect(() => {
        // 유저 상세 조회 응답의 userCards 로 회원카드 목록을 받아옴
        const loadAsync = async () => {
            try {
                const tokenResponse = await dispatch(csmsGetApiKey());
                if (!tokenResponse.payload || !tokenResponse.payload.data) {
                    alert(serverErrAlertMessage);
                    return;
                }
                const csmsToken = tokenResponse.payload.data.accessToken;
                setCsmsToken(csmsToken);

                const response = await dispatch(csmsGetUser(user.id, csmsToken));
                if (response.payload.result === ResponseResult.OK) {
                    setUserInfo(response.payload.data);
                } else {
                    alert(response.payload.msg);
                }
            } catch (e) {
                alert(serverErrAlertMessage);
            }
        }
        loadAsync();
    }, []);

    const onClickRequestMembercard = () => {
        if (PhysicalCard || CardOffer !== "NONE") {
            return;
        }

        if (!CsmsToken || !UserInfo.cloudId) {
            alert(serverErrAlertMessage);
            return;
        }

        setModalRequestShow(true);
    }

    return (
        <React.Fragment>
            <NavBar />
            <div css={[MyPageWrap, css`
                word-break: keep-all;
                @media (max-width: 640px) {
                    .card {
                        min-width: unset;
                        min-height: unset;
                    }
                }
            `]}>
                <Card>
                    <Card.Body>
                        <h1>마이페이지</h1>
                        <Tab list={mypage_tab} active={3} userId={1}></Tab>
                        <TabContent>
                            <div css={css`
                                margin-top: 119px;
                                border-top: 1px solid ${stroke_gray1};
                                > div:not(:last-of-type) {
                                    border-bottom: 1px solid ${stroke_gray1};
                                }
                            `}>
                                <div css={rowStyle}>
                                    <h2>모바일카드</h2>
                                    <h2>{MobileCard?.cardNo ? cardNoFormat(MobileCard.cardNo) : "-"}</h2>
                                </div>
                                <div css={rowStyle}>
                                    <h2>실물카드</h2>
                                    {
                                        PhysicalCard
                                            ? <h2>{cardNoFormat(PhysicalCard.cardNo)}</h2>
                                            : CardOffer === "REQUEST"
                                                ? <h2>{CARD_OFFER_LABEL.REQUEST}</h2>
                                                : <div css={css`width: 110px; height: 28px;`}>
                                                    <button type="button" css={BtnOutLineGray2} onClick={onClickRequestMembercard}>신청하기</button>
                                                </div>
                                    }
                                </div>
                            </div>
                            <div css={css`
                                margin-top: 27px;
                                padding: 24px;
                                background: ${scroll_gray};
                                border: 1px solid #DDDDDD;
                                border-radius: 8px;
                                font-size: 13px;
                                line-height: 22px;
                            `}>
                                <p css={css`display: flex; align-items: center; gap: 8px; font-weight: 700; margin-bottom: 8px;`}>
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M13 16H12V12H11M12 8H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke={typo_light_blue} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                    실물카드로 로밍 충전소 이용이 가능합니다.
                                </p>
                                <ul css={css`margin: 0; padding-left: 26px; color: ${stroke_gray2}; list-style: disc;`}>
                                    <li>실물카드는 신청일로부터 영업일 기준 10일 이내로 배송됩니다.</li>
                                    <li>분실 또는 파손 시 재발급이 가능하며, 비용이 발생합니다.</li>
                                    <li>실물카드는 회원정보에 등록된 주소로 배송되므로, 신청 전 주소를 확인해 주시기 바랍니다.</li>
                                </ul>
                            </div>
                        </TabContent>
                    </Card.Body>
                </Card>
            </div>
            <div css={css`width: 100%; height: 100vh`}>
                <Footer />
            </div>
            <ModalMembercardRequest
                show={ModalRequestShow}
                onHide={() => setModalRequestShow(false)}
                cloudId={UserInfo.cloudId}
                rdnmadr={UserInfo.rdnmadr}
                adres={UserInfo.adres}
                adresDetail={UserInfo.adresDetail}
            />
        </React.Fragment>
    );
};

export default MembercardPage;
